<template>
  <Modal
    id="PayModeEdit"
    width="80%"
    :visible="visible"
    @cancel="visible = !visible"
    @ok="submit"
    :title="title"
    :zIndex="9999999900"
  >
    <Row align="middle" justify="center">
      <Col span="18" class="content">
        <Row>
          <Col span="24">
            <Form
              ref="payModeForm"
              :model="form"
              layout="vertical"
              :rules="validateRules"
            >
              <Row justify="space-around">
                  <Col span="10">
                    <FormItem :label="$t('payMode.field.pay_mode')" name="payMode">
                      <Input :placeholder="$t('payMode.validate.required.pay_mode')"
                             v-model:value="form.payMode">
                      </Input>
                  </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem :label="$t('payMode.field.quantity')" name="quantity">
                      <InputNumber
                              v-model:value="form.quantity"
                              :placeholder="$t('payMode.validate.required.quantity')"
                      />
                  </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem :label="$t('payMode.field.status')" name="status">
                      <Select
                              v-model:value="form.status"
                              :placeholder="$t('payMode.validate.required.status')"
                              :options="selectList.statusList"
                              :dropdownStyle="{ zIndex: 9999999950 }"
                      >
                      </Select>
                  </FormItem>
                  </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>

<script>
import {
  Modal,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Image,
  Radio,
  Steps,
  Step,
  Button,
  message,
  Select,
  DatePicker,
  InputGroup,
  Upload,
  Descriptions,
  DescriptionsItem,
} from "ant-design-vue";
import {
  UploadOutlined,
  UserOutlined,
  SolutionOutlined,
  FileImageOutlined,
  CheckOutlined,
  PlusOutlined,
} from "@ant-design/icons-vue";
import { PayModeAdd } from "@/api/PayModeAdd";
import { PayModeEdit } from "@/api/PayModeEdit";


export default {
  name: "PayModeEdit",
  components: {
    Modal,
    Row,
    Col,
    UserOutlined,
    SolutionOutlined,
    FileImageOutlined,
    CheckOutlined,
    UploadOutlined,
    PlusOutlined,
    Form: Form,
    FormItem: Form.Item,
    Input: Input,
    InputPassword: Input.Password,
    Textarea:Input.TextArea,
    InputGroup,
    InputNumber,
    Image,
    RadioGroup: Radio.Group,
    RadioButton: Radio.Button,
    Steps,
    Step,
    Button,
    message,
    Select,
    SelectOption: Select.Option,
    DatePicker,
    Upload,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      visible: false,
      actionType: "",
      form: {
        idPayMod : "",
        payMode : "",
        quantity : "",
        createDate : "",
        status : "",
      },
      fileList: {
      },
      selectList: {
        statusList: [{value: 0,label: 'Off'},{value:1,label: 'On'}],
      },
      validateRules: {
        idPayMod: [
          {
            required: true,
            message: this.$t("payMode.validate.required.id_pay_mod"),
            trigger: "change",
            type: "number",
          },
        ],
        payMode: [
          {
            required: true,
            message: this.$t("payMode.validate.required.pay_mode"),
            trigger: "change",
          },
        ],
        quantity: [
          {
            required: true,
            message: this.$t("payMode.validate.required.quantity"),
            trigger: "change",
            type: "number",
          },
        ],
        createDate: [
          {
            required: true,
            message: this.$t("payMode.validate.required.create_date"),
            trigger: "change",
          },
        ],
        status: [
          {
            required: true,
            message: this.$t("payMode.validate.required.status"),
            trigger: "change",
            type: "number",
          },
        ],
      },
    };
  },
  computed: {
    title: function () {
      let name = "";
      switch (this.actionType) {
        case "add":
          name = this.$t("public.name.add");
          break;
        case "edit":
          name = this.$t("public.name.edit");
          break;
      }
      return name;
    },
  },
  methods: {
    addShow() {
      this.actionType = "add";
      this._resetData();
      this.visible = true;
    },
    async editShow(obj) {
      this._resetData();
      this.actionType = "edit";
      this.form = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
    submit() {
      this.$refs["payModeForm"]
        .validate()
        .then(() => {
          let api;
          switch (this.actionType) {
            case "add":
              console.log("add");
              api = new PayModeAdd();
              break;
            case "edit":
              console.log("edit");
              api = new PayModeEdit();
              break;
            default:
              return false;
          }
          api.post(this.form).then((response, any) => {
            if (0 == parseInt(response.data.code)) {
              message.success(response.data.msg);
              this.$emit("updateList");
              this.visible = false;
            } else {
              message.error(response.data.msg);
            }
          });
        })
        .catch(() => {
        });
    },
    // reset data
    _resetData() {
      this.form = {
        idPayMod : "",
        payMode : "",
        quantity : "",
        createDate : "",
        status : "",
      };
    },
  },
};
</script>

<style lang="less">
</style>